import { FunctionComponent, useEffect, useState } from 'react';
import ConfirmationDialogue from '../../../Compound/ConfirmationDialogue/ConfirmationDialogue';

type UploadFileUploadProps = {
  companyName: string;
  buttonBackgroundColor: string;
  buttonTextColor: string;
  shouldDeleteFile: boolean;
  language: string;
  removeFileName: (e: string) => void;
  removeBase64: (e: string) => void;
  handleShouldDeleteFile: (e: boolean) => void;
  onDeleteClick: () => void;
};

type FC = FunctionComponent<UploadFileUploadProps>;

const UploadFileDialogue: FC = (props: UploadFileUploadProps) => {
  const {
    companyName,
    buttonBackgroundColor,
    buttonTextColor,
    shouldDeleteFile,
    language,
    removeFileName,
    removeBase64,
    handleShouldDeleteFile,
    onDeleteClick,
  } = props;
  const [name, setName] = useState(companyName);
  const [successButtonName, setSuccessButtonName] = useState('');
  const [cancelButtonName, setCancelButtonName] = useState('');

  useEffect(() => {
    if (companyName !== '') {
      setName(`${companyName}`);
    } else {
      setName('this');
    }
  }, [companyName]);

  useEffect(() => {
    if (language === 'en') {
      setSuccessButtonName('Delete File');
      setCancelButtonName('Cancel');
    } else {
      setSuccessButtonName('Supprimer le fichier');
      setCancelButtonName('Annuler');
    }
    return () => {
      setSuccessButtonName('');
      setCancelButtonName('');
    };
  }, [language]);

  return (
    <ConfirmationDialogue
      isVisible={shouldDeleteFile}
      title={
        language === 'en'
          ? 'Are you sure you want to delete this file?'
          : 'Êtes-vous sûr de vouloir supprimer ce fichier?'
      }
      status="cautionary"
      variant="onBoarding"
      subTitle={
        language === 'en'
          ? `This file will be permanently deleted from ${name} Application Form.`
          : `Ce fichier sera définitivement supprimé du formulaire de candidature ${name}.`
      }
      width="490px"
      buttonBackgroundColor={buttonBackgroundColor}
      buttonTextColor={buttonTextColor}
      buttonWidth={language === 'en' ? '110px' : '162px'}
      confirm={{
        label: successButtonName,
        action: () => {
          removeFileName('');
          removeBase64('');
          handleShouldDeleteFile(false);
          onDeleteClick();
        },
      }}
      cancel={{
        label: cancelButtonName,
        action: () => {
          handleShouldDeleteFile(false);
        },
      }}
    />
  );
};

export default UploadFileDialogue;
